module.exports = __webpack_public_path__ + "static/media/logo.3cb14c19.png";